export default __webpack_public_path__ + "img/2_1-78a3298c.png";